var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex px-2 -mx-2 rounded-sm",
      class: { "font-medium": _vm.chapter.active },
      style: _vm.style,
      attrs: { "data-test": "tab-chapters--entry" },
      on: { mouseover: _vm.mouseOverHandler, mouseleave: _vm.mouseLeaveHandler }
    },
    [
      _c(
        "span",
        {
          staticClass:
            "cursor-pointer w-8 py-2 mr-2 flex items-center justify-center",
          attrs: { "aria-hidden": "true" },
          on: {
            click: function($event) {
              return _vm.selectChapter()
            }
          }
        },
        [
          _vm.action.icon
            ? _c("icon", {
                attrs: {
                  type: _vm.action.icon,
                  size: 24,
                  "data-test": "tab-chapters--trigger--" + _vm.action.icon
                }
              })
            : _c("span", { attrs: { "data-test": "tab-chapters--index" } }, [
                _vm._v(_vm._s(_vm.action.content))
              ])
        ],
        1
      ),
      _c("chapter-progress", {
        staticClass: "w-full",
        attrs: {
          chapter: _vm.chapter,
          showLink: true,
          playtime: _vm.playtime,
          ghost: _vm.ghost,
          progressColor: _vm.progressColor
        },
        on: {
          chapter: _vm.dispatch,
          play: _vm.dispatch,
          ghost: _vm.dispatch,
          simulate: _vm.dispatch,
          playtime: _vm.dispatch,
          hover: _vm.linkMouseover
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }